<template>
    <u-card-elevated-tile v-bind="{ elevation, ...$attrs }">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-card-elevated-tile>
</template>

<script>
import UCardElevatedTile from "@/components/publish/styles/cards/u-card-elevated-tile.vue";

export default {
    props: {},
    components: {
        UCardElevatedTile,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
